import { Routes } from '@angular/router';
import { collectRoutes } from '../collect/collect.routes';
import { administrationRoutes } from '../administration/administration.routes';
import { reportAnalysisRoutes } from '../report-analysis/report-analysis.routes';
import { billingsSettlementRoutes } from '../billings-settlement/billings-settlement.routes';
import { PermissionsEnum } from '../permission.enum';
import { permissionGuard } from '../shared/core/guard/permission.guard';

export const midaPageRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('../dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'collect',
    loadComponent: () => import('../collect/collect.component').then((m) => m.CollectComponent),
    children: collectRoutes,
  },
  {
    path: 'report&analysis',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('../report-analysis/components/report-analysis-home/report-analysis-home.component').then((m) => m.ReportAnalysisHomeComponent),
    children: reportAnalysisRoutes,
  },
  {
    path: 'billings&settlement',
    canActivate: [permissionGuard(PermissionsEnum.BillingView)],
    loadComponent: () => import('../billings-settlement/billings-settlement.component').then((m) => m.BillingsSettlementComponent),
    children: billingsSettlementRoutes,
  },
  {
    path: 'mandates&tokens',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('../mandates-tokens/mandates-tokens.component').then((m) => m.MandatesTokensComponent),
  },
  {
    path: 'administration',
    loadComponent: () => import('../administration/administration.component').then((m) => m.AdministrationComponent),
    children: administrationRoutes,
  },
  {
    path: 'feedback-portal',
    loadComponent: () => import('../feedback-portal/feedback-portal.component').then((m) => m.FeedbackPortalComponent),
  },
  {
    path: 'profile',
    loadComponent: () => import('../profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: 'notifications',
    loadComponent: () => import('./components/notifications/notifications.component').then((m) => m.NotificationsComponent),
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];
